import { Stack, TextField, IconButton, Typography, Box } from "@mui/material";
import { ArrowDownward, ArrowUpward, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import Theme from "../utils/theme";
import { useMemo } from "react";

interface IProcedureInputProps {
    index: number;
    value: string;
    onBlur: (index: number) => void;
    onChange: (index: number, value: string) => void;
    onRemove: (index: number) => void;
    onUpdateOrder: (index: number, type: "up" | "down") => void;
}

const ProcedureInput = ({ index, value, onBlur, onChange, onRemove, onUpdateOrder }: IProcedureInputProps) => {
    const themeState = useSelector((state: RootState) => state.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);

    return (
        <Stack direction="column" spacing={1} alignItems="stretch" sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                <Typography variant="subtitle2" sx={{ fontSize: "16px", flexGrow: 1 }}>{`Step ${index + 1}`}</Typography>

                <Box sx={{ display: "flex" }}>
                    <IconButton
                        onClick={() => onRemove(index)}
                        size="small"
                        sx={{
                            mt: "4px",
                            color: theme.palette.primary.main,
                            "&:hover": { color: theme.palette.primary.main },
                        }}
                    >
                        <Delete fontSize="small" />
                    </IconButton>

                    <IconButton
                        onClick={() => {
                            onUpdateOrder(index, "up");
                        }}
                        size="small"
                        sx={{
                            mt: "4px",
                            color: theme.palette.primary.main,
                            "&:hover": { color: theme.palette.primary.main },
                        }}
                    >
                        <ArrowUpward fontSize="small" />
                    </IconButton>

                    <IconButton
                        onClick={() => {
                            onUpdateOrder(index, "down");
                        }}
                        size="small"
                        sx={{
                            mt: "4px",
                            color: theme.palette.primary.main,
                            "&:hover": { color: theme.palette.primary.main },
                        }}
                    >
                        <ArrowDownward fontSize="small" />
                    </IconButton>
                </Box>
            </Box>

            <TextField
                value={value}
                onChange={(e) => onChange(index, e.target.value)}
                fullWidth
                multiline
                variant="filled"
                label="Instruction"
                onBlur={() => onBlur(index)}
                sx={{
                    backgroundColor: "#fff",
                    borderRadius: 1,
                    "& .MuiFilledInput-root": {
                        borderRadius: 1,
                        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.12)",
                        "&:hover": {
                            boxShadow: "inset 0 0 0 2px #F97316",
                        },
                        "&.Mui-focused": {
                            boxShadow: "inset 0 0 0 2px #F97316",
                            backgroundColor: "#fff",
                        },
                    },
                }}
            />
        </Stack>
    );
};

export default ProcedureInput;
